/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

/* Thunks */

import draftApi from '../../../api/draft.api';
import { createFOAsyncThunk } from '../../helpers/thunk.helpers';

/**
 * Fetches the submission rows from the server
 */
export const patchLockSubmissionThunk = createFOAsyncThunk('submission/patchLockSubmission', async ({ submissionId }) =>
  draftApi.lockById(submissionId),
);

export const patchUnlockSubmissionThunk = createFOAsyncThunk(
  'submission/patchUnlockSubmission',
  async ({ submissionId }) => draftApi.unlockById(submissionId),
);
